// extracted by mini-css-extract-plugin
export default {"iconReupload":"IconReupload_iconReupload__vJ66r"};